import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-white mb-4">
              株式会社<span className="text-primary-400">Ｄｒｅａｍ</span>
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              営業支援・コンサルティング・システム開発まで、
              ビジネスのあらゆる課題をワンストップで解決します。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">リンク</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">ホーム</Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">料金プラン</Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">プライバシーポリシー</Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">お問い合わせ</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">会社概要</h4>
            <ul className="flex flex-col gap-2 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5 flex-shrink-0" />
                <span>神奈川県横浜市西区北幸２丁目１０番４８号むつみビル３階</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-user-line text-primary-400 flex-shrink-0" />
                <span>代表取締役　笹川俊</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400 flex-shrink-0" />
                <a href="mailto:banking@dream-dreaminc.com" className="hover:text-primary-400 transition-colors duration-200">
                  banking@dream-dreaminc.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 株式会社Ｄｒｅａｍ. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
              プライバシーポリシー
            </Link>
            <Link to="/contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
